'use strict';
const updateElementWithItineraries = require('../filters/utils/update_element_with_itineraries');
const trackingUtils = require('../../modules/utils/tracking.utils');
const filterParser = require('../filters/utils/parser');
const tripTypeUtils = require('od-modules/utils/trip_type');
const filterContainers = ['filter_airports', 'filter_stops', 'filter_airlines', 'filter_times'];

module.exports = {
    filtersAreInitialized: false,
    filtersTypes: {
        AIRPORTS: 0,
        STOPS: 1,
        AIRLINES: 2,
        TIMES: 3,
    },

    filterContainers,

    _tracktEvent(label) {
        trackingUtils.trackEventWithCategory('flights_results', 'results_filters', label);
    },

    _trackStopoversFilter(id) {
        if (!Odigeo._.isUndefined(id)) {
            const airportLabel = $('label[for=' + id + ']').text().toLowerCase().replace(/\s/g, '_');
            const iata = airportLabel.substr(-5).substr(1, 3);
            const $el = this.$widget.find('#' + id);
            const idx = parseInt($el.attr('name').substr(-1), 10) + 1;

            this._tracktEvent(idx + '_segment_stops_connection_airports_' + ($el.is(':checked') ? 'checked_' : 'unchecked_') + iata);
        }
    },

    selectors: {
        resultspage_expandable_container: '.resultspage_expandable_container',
        filters_container: '.filters_container',
        filters_layer_summary: '.filters_layer_summary',
        filters_layer_footer: '.filters_layer_footer',
        filters_back_arrow: '.filters_back_arrow',
        filter_flights_buttons_container: '.filter_flights',
        filter_flights_buttons: '.filter_flights ul',
        close_filters_button: '.close_filters',
        waiting_page: '.waiting_page',
        section_page: '.resultspage_section',
        filter_page: '#filter',
        one_stop_radio: '#radio-from-1-stopovers-0',
        non_stop_radio: '#radio-from-0-stopovers-0',
        result_container: '#results-manager',
        primeFilterSelector: '.prime_filter_selector',
        primeFilterDescription: '.prime_filter_description',
        primeFilterDescriptionLabel: '.prime_filter_description_label',
        primeFilterCollapse: '#collapse-item-membership',
    },

    toggleFiltersContainersVisibility(isVisible) {
        this.$cachedSelectors.filters_container.toggleClass('odf-hidden', !isVisible);
        this.$cachedSelectors.filters_layer_summary.toggleClass('odf-hidden', !isVisible);
        this.$cachedSelectors.filters_layer_footer.toggleClass('odf-hidden', !isVisible);
        this.$cachedSelectors.filters_back_arrow.toggleClass('odf-hidden', !isVisible);
    },

    cacheFilterContainers() {
        const widget = this.widget;

        for (var i = 0; i < widget.numFlights; i++) {
            this.removeSelectorFromCache(this.filterContainers[this.filtersTypes.AIRPORTS] + i);
            this.removeSelectorFromCache(this.filterContainers[this.filtersTypes.AIRPORTS] + i + '_origin_input');
            this.removeSelectorFromCache(this.filterContainers[this.filtersTypes.AIRPORTS] + i + '_destination_input');
            this.removeSelectorFromCache(this.filterContainers[this.filtersTypes.STOPS] + i);
            this.removeSelectorFromCache(this.filterContainers[this.filtersTypes.STOPS] + i + '_stopover_input');
            this.removeSelectorFromCache(this.filterContainers[this.filtersTypes.AIRPORTS] + i + '_stopover_input');
            this.removeSelectorFromCache(this.filterContainers[this.filtersTypes.AIRLINES] + i);
            this.removeSelectorFromCache(this.filterContainers[this.filtersTypes.AIRLINES] + i + '_input');
            this.removeSelectorFromCache(this.filterContainers[this.filtersTypes.AIRLINES] + i + '_lowCost');
            this.removeSelectorFromCache(this.filterContainers[this.filtersTypes.AIRLINES] + i + '_train');
            this.removeSelectorFromCache(this.filterContainers[this.filtersTypes.TIMES] + i);
            this.addSelectorToCache(this.filterContainers[this.filtersTypes.AIRPORTS] + i, this.$widget.find('.filter_airports' + i));
            this.addSelectorToCache(this.filterContainers[this.filtersTypes.STOPS] + i, this.$widget.find('.filter_stops' + i));
            this.addSelectorToCache(this.filterContainers[this.filtersTypes.AIRLINES] + i, this.$widget.find('.filter_airlines' + i));
            this.addSelectorToCache(this.filterContainers[this.filtersTypes.TIMES] + i, this.$widget.find('.filter_times' + i));

            this.addSelectorToCache(this.filterContainers[this.filtersTypes.AIRPORTS] + i + '_origin_input',
                this.$cachedSelectors[this.filterContainers[this.filtersTypes.AIRPORTS] + i].find('[name=origin' + i + ']'));

            this.addSelectorToCache(this.filterContainers[this.filtersTypes.AIRPORTS] + i + '_destination_input',
                this.$cachedSelectors[this.filterContainers[this.filtersTypes.AIRPORTS] + i].find('[name=destination' + i + ']'));

            this.addSelectorToCache(this.filterContainers[this.filtersTypes.STOPS] + i + '_stopover_input',
                this.$cachedSelectors[this.filterContainers[this.filtersTypes.STOPS] + i].find('input[name=stopover' + i + ']'));

            this.addSelectorToCache(this.filterContainers[this.filtersTypes.AIRPORTS] + i + '_stopover_input',
                this.$cachedSelectors[this.filterContainers[this.filtersTypes.AIRPORTS] + i].find('[name=stopover' + i + ']'));

            this.addSelectorToCache(this.filterContainers[this.filtersTypes.AIRLINES] + i + '_input',
                this.$cachedSelectors[this.filterContainers[this.filtersTypes.AIRLINES] + i].find('[name=airlines' + i + ']'));

            this.addSelectorToCache(this.filterContainers[this.filtersTypes.AIRLINES] + i + '_lowCost',
                this.$cachedSelectors[this.filterContainers[this.filtersTypes.AIRLINES] + i].find('#includeLowCosts' + i));

            this.addSelectorToCache(this.filterContainers[this.filtersTypes.AIRLINES] + i + '_train',
                this.$cachedSelectors[this.filterContainers[this.filtersTypes.AIRLINES] + i].find('#includeTrains' + i));
        }

        this.removeSelectorFromCache('one_stop_radio');
        this.removeSelectorFromCache('non_stop_radio');
        this.removeSelectorFromCache('result_container');
        this.addSelectorToCache('one_stop_radio', this.$widget.find('#radio-from-1-stopovers-0'));
        this.addSelectorToCache('non_stop_radio', this.$widget.find('#radio-from-0-stopovers-0'));
        this.addSelectorToCache('result_container', this.$widget.find('#results-manager'));

        const {membershipPriceDisplayDesktop} = Odigeo.Membership;
        if (membershipPriceDisplayDesktop === 'FILTER_STICKY') {
            this.removeSelectorFromCache('primeFilterSelector');
            this.removeSelectorFromCache('primeFilterDescription');
            this.removeSelectorFromCache('primeFilterDescriptionLabel');
            this.removeSelectorFromCache('primeFilterCollapse');
            this.addSelectorToCache('primeFilterSelector', this.$el.find('.prime_filter_selector'));
            this.addSelectorToCache('primeFilterDescription', this.$el.find('.prime_filter_description'));
            this.addSelectorToCache('primeFilterDescriptionLabel', this.$el.find('.prime_filter_description_label'));
            this.addSelectorToCache('primeFilterCollapse', this.$el.find('#collapse-item-membership'));
        }

        if (tripTypeUtils.isMultipleDestinations(widget.tripType)) {
            const self = this;
            this.$cachedSelectors.filter_flights_buttons.find('li').slice(0, widget.numFlights).each(function(index) {
                const segment = JSON.parse(Odigeo.Session.get('searchParameters')).searchSegments[index];
                const separator = (self.widget.options.multipleTripSeparator === 'long') ? ' - ' : '-';
                const title = segment.departure.iata + separator + segment.destination.iata;

                $(this).toggleClass('hidden', false);
                $(this).toggleClass('active', index === 0);
                $(this).find('.flight_title').text(title);
            });
        }
    },

    unbindFromDom() {
        if (this.isDomBinded) {
            this.$cachedSelectors.filter_flights_buttons.off(Odigeo.Events.tap);
            $('.resultspage_expandable_container').off(Odigeo.Events.swipeLeft);
            Odigeo.unbind('results:slideLeft');
            this.isDomBinded = false;
        }
    },
    /* * * * * View methods * * * * */

    // Filters
    /**
     Set to active the corresponding filter container.
     @param {Number} idx of the filter
     @param {Boolean} activateAllFlights: this param indicate if you should activate all flights or only the activate flight
     @return {Number} the active filter after the operation
     */
    setActiveFilter(idx, activateAllFlights) {
        const activeFilter = this.widget.activeFilter;
        const widget = this.widget;
        let i;
        let n;

        // We do nothing if the active state is not changing
        if (activeFilter !== idx) {
            // Hide the activeFilter if is activated
            if (activeFilter !== -1) {
                if (activateAllFlights) {
                    for (i = 0, n = widget.numFlights; i < n; i++) {
                        this.$cachedSelectors[this.filterContainers[activeFilter] + i].removeClass('active');
                    }
                } else {
                    this.$cachedSelectors[this.filterContainers[activeFilter] + widget.activeFlight].removeClass('active');
                }
            }
            // Shows the desired filter
            if (idx !== -1) {
                if (activateAllFlights) {
                    for (i = 0, n = widget.numFlights; i < n; i++) {
                        this.$cachedSelectors[this.filterContainers[idx] + i].addClass('active');
                    }
                } else {
                    if (this.$cachedSelectors[this.filterContainers[idx] + widget.activeFlight] instanceof $) {
                        this.$cachedSelectors[this.filterContainers[idx] + widget.activeFlight].addClass('active');
                    }
                }
            }
            this.widget.activeFilter = idx;
        }

        return this.widget.activeFilter;
    },

    toggleTabVisibility(idx) {
        const activeFilter = this.widget.activeFilter;
        const cachedSelectors = this.$cachedSelectors;
        const maxFlights = this.widget.numFlights;
        let i;

        if (activeFilter === -1) {
            // Hide all filters
            Odigeo._.each(this.filterContainers, function(filter) {
                for (i = 0; i < maxFlights; i++) {
                    cachedSelectors[filter + i].removeClass('active').addClass('od-flightfilters-tab-disabled');
                }
            });
        } else {
            // Hide the activeFilter if is activated
            Odigeo._.each(this.filterContainers, function(filter) {
                cachedSelectors[filter + activeFilter].removeClass('active').addClass('od-flightfilters-tab-disabled');
            });
        }

        // Shows the desired filter
        Odigeo._.each(this.filterContainers, function(filter) {
            if (cachedSelectors[filter + idx] instanceof $) {
                cachedSelectors[filter + idx].removeClass('od-flightfilters-tab-disabled').addClass('active');
            }
        });
    },

    setActiveLeg(idx) {
        const activeFilter = this.widget.activeFilter;
        const currentTabIndex = activeFilter < 0 ? 0 : activeFilter;
        this.model.toggleFilterSummaries(currentTabIndex, idx);
        const msg = {
            filtersMetadataAll: Odigeo._.zipObject([idx], [$('#metadata' + idx).data()]),
        };
        const timeMetadata = filterParser.parseFilterTimeMetadata(msg, idx);

        // We do nothing if the active state is not changing
        if (activeFilter !== idx) {
            this.toggleTabVisibility(idx);
            Odigeo.trigger('time-filter:update', idx, timeMetadata, true);
            this.widget.activeFilter = idx;
        }

        return this.widget.activeFilter;
    },

    computeSpecialIndexes(idx) {
        return tripTypeUtils.isRoundTrip(this.widget.tripType) ? [0, 1] : [idx];
    },

    updateFilterFields(idx, data, isRestoringStatus) {
        const specialIndexes = this.computeSpecialIndexes(idx);
        Odigeo.trigger('stopover-duration-filter:update', idx, data.stopoverDuration[idx]);
        Odigeo.trigger('airlines-filter:update', idx, data.airlines[idx]);
        this.updateStopoverFilter(idx, data.stopoverConnection[idx]);

        Odigeo._.each(specialIndexes, Odigeo._.bind(function(index) {
            Odigeo.trigger('flight-duration-filter:update', index, data.flightDuration[index]);
            Odigeo.trigger('time-filter:update', index, data.time[index], true, isRestoringStatus);
        }, this));

        this.widget.view.currentTimeFilter = '';
    },

    updateFilters(data, isRestoringStatus) {
        const widget = this.widget;
        const isVisible = tripTypeUtils.isMultipleDestinations(widget.tripType);
        for (let i = 0; i < widget.numFlights; i++) {
            this.updateFilterFields(i, data, isRestoringStatus);
        }

        this.$cachedSelectors['filter_flights_buttons_container'].css('visibility', isVisible ? 'visible' : 'hidden');
        Odigeo.trigger(`${widget.id}:filterUpdated`, data.time);
    },
    initializeFilterFields(idx, data) {
        const specialIndexes = this.computeSpecialIndexes(idx);
        const widget = this.widget;
        const widgetId = widget.id;
        Odigeo.trigger(widgetId + ':init', 'airlines_filter', idx, data.airlines[idx]);
        Odigeo.trigger(widgetId + ':init', 'airports_filter', idx, data.airports[idx]);
        Odigeo.trigger(widgetId + ':init', 'airports_filter', 'stopover-' + idx, data.airports[idx]);
        Odigeo.trigger(widgetId + ':init', 'stopover_duration_filter', idx, data.stopoverDuration[idx]);
        Odigeo.trigger(widgetId + ':init', 'stopover_quantity_filter', idx);
        Odigeo._.each(specialIndexes, Odigeo._.bind(function(index) {
            Odigeo.trigger(widgetId + ':init', 'time_filter', index, data.time[index]);
            Odigeo.trigger(widgetId + ':init', 'time_ranges_filter', index, data.timeRanges[index]);
            Odigeo.trigger(widgetId + ':init', 'flight_duration_filter', index);
        }, this));
    },
    initializeFilters(msg) {
        const widget = this.widget;
        Odigeo.trigger('filter-by-cities:init');
        Odigeo.trigger(`${widget.id}:initTransportTypeFilter`, this.$el.find('#transport_type_filter'));
        if (Odigeo.AB.isChangeFlightFreeChargeMobile || Odigeo.AB.isChangeFlightFreeChargeDesktop || Odigeo.AB.isPrimeDays) {
            Odigeo.trigger(`${widget.id}:initFreeRebooking`, this.$el.find('#free_rebooking_filter'));
        }
        if (tripTypeUtils.isMultipleDestinations(widget.tripType)) {
            for (let i = 0; i < widget.numFlights; i++) {
                this.initializeFilterFields(i, msg);
            }
        } else {
            this.initializeFilterFields(0, msg);
        }
    },

    /* filterbystopover*/
    updateStopoverFilter(idx, fMetadata) {
        updateElementWithItineraries([{
            cache: 'filter_stops' + idx + '_stopover_input',
            meta: 'stopoversMetadata',
        }], fMetadata, this.$cachedSelectors);
    },
    // **** Errors & Waitings **** //
    showFiltersLoading() {
        // TODO: remove swipe to close and test again
        // this.$widget.find('input[data-type=range]').trigger('disable');
        this.$widget.find('.filters_loading').toggleClass('hidden', false);
    },
    hideFiltersLoading() {
        // this.$widget.find('input[data-type=range]').trigger('enable');
        this.$widget.find('.filters_loading').toggleClass('hidden', true);
    },
    checkNullFilters(applyFiltersTrigger) {
        $.when(this.model.checkNoAirlinesSelected(), this.model.checkNoAirportsSelected()).then(Odigeo._.bind(function() {
            if (Odigeo._.some(arguments) || this.model.get('numFilteredResults') === 0) {
                Odigeo.trigger(`${this.widget.id}:zeroFilteredResults`);
            } else {
                window.history.back();
                Odigeo.trigger(`${this.widget.id}:closeFiltersLayer`, applyFiltersTrigger);
            }
        }, this));
    },

    handleTouchables() {
        const classesToRemove = {
            '.filtersmanager_filterrow_airlines': 'od-filtersmanager-filterrow-airlines-hover',
            '.filtersmanager_filterrow_data_button': 'od-filtersmanager-filterrow-data-button-hover',
            '.filtersmanager_filterrow_airports': 'od-filtersmanager-filterrow-airports-hover',
            '.filtermanager_airport_price': 'od-filtermanager-airport-price-hover',
        };
        Odigeo._.each(classesToRemove, function(classToRemove, parentElement) {
            this.$el.find(parentElement).removeClass(classToRemove);
        }, this);
    },
    clearSummaryTagsInMultiTrips() {
        const summariesContaniersInFilter = this.el.querySelectorAll('.summary_label');
        summariesContaniersInFilter.forEach((e) => e.classList.remove('od-summary-label'));
    },

    updateAirlinesIfFreeRebookingFilter(isChecked, airlinesList) {
        const widget = this.widget;
        if (tripTypeUtils.isMultipleDestinations(widget.tripType)) {
            for (let i = 0; i < widget.numFlights; i++) {
                Odigeo.trigger(`${widget.id}:updateIfFreeRebookingFilter`, i, isChecked, airlinesList);
            }
        } else {
            Odigeo.trigger(`${widget.id}:updateIfFreeRebookingFilter`, 0, isChecked, airlinesList);
        }
    },

    enableAllAirlineInputs() {
        const widget = this.widget;
        if (tripTypeUtils.isMultipleDestinations(widget.tripType)) {
            for (let i = 0; i < widget.numFlights; i++) {
                Odigeo.trigger(`${widget.id}:enableAirlineInputs`, i);
            }
        } else {
            Odigeo.trigger(`${widget.id}:enableAirlineInputs`, 0);
        }
    },
};
